<nav class="breadcrumb-wrapper breadcrumb" aria-label="breadcrumb">
  <ng-container *ngIf="fromDashboard$ | async">
    <a class="breadcrumb-link" [routerLink]="[dashboardRoute]" [queryParams]="dashboardQueryParams$ | async">{{ dashboardLabel }}</a>
    <span class="breacrumb-arrow">/</span>
  </ng-container>
  <xng-breadcrumb class="breadcrumb">
    <ng-container *xngBreadcrumbItem="let breadcrumb">
      <ng-container>{{ breadcrumb }}</ng-container>
    </ng-container>
  </xng-breadcrumb>
</nav>
